///<reference path="./smart-mover.models.ts"/>
///<reference path="filter-base.ts"/>


module Meevo.Components.Controls.SmartMover {

    export abstract class InteractiveFilter extends FilterBase implements IInteractiveFilter {
        abstract templateName: FilterTemplateNames;

        abstract filter(entities: ISmartMoverModel<any>[]): ISmartMoverModel<any>[];
    }
}